import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { LangModule } from 'src/app/modules/lang/lang.module';
import { PrivateRoutingModule } from '../private-routing.module';
import { PageSelectorComponent } from './page-selector/page-selector';
import { PaginatorComponent } from './paginator/paginator.component';
import { ProfilePopoverComponent } from './profile-popover/profile-popover.component';

const COMPONENTS = [
	PageSelectorComponent,
	PaginatorComponent,
	ProfilePopoverComponent
];

@NgModule({
	declarations: [...COMPONENTS],
	imports: [
		IonicModule,
		CommonModule,
		LangModule,
		PrivateRoutingModule
	],
	entryComponents: [...COMPONENTS],
	exports: [...COMPONENTS]
})
export class ComponentsModule { }
